import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9295ddca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-login-form-code" }
const _hoisted_2 = { class: "user-login-form-agreement" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#1a1a1a","flex-shrink":"0"} }, "我同意遵守", -1))
const _hoisted_4 = { style: {"color":"#fa8203","cursor":"pointer"} }

import { ref, withDefaults, watch } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseFormRef,
  BaseButton,
  BaseFormProps,
  BaseCheckbox,
  XrkSlideVerify,
  XrkMessageBox
} from 'xrk-components';

import type { FormData, FormProps } from '../../types/index';
import { validatorPassword, validatorPhone } from '@/utils/validator';
import {
  FormItemEnum,
  AgreementEnum,
  LoginTypeEnum
} from '../../constants/index';
import { imageJson, lastProtocol, lastPolicy } from '@data-source/common/apis';
import { sendMessageCode } from '../../data-source/apis';
import { formatter } from '@/utils';
import { PLATFORM_NAME } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'login-form',
  props: {
    itemList: {},
    pageType: { default: '' },
    formData: { default: () => {
    return {};
  } }
  },
  setup(__props: any, { expose: __expose }) {

const AGREEMENT_MAPPING = {
  1: {
    api: lastProtocol,
    title: `${PLATFORM_NAME}服务平台用户协议`
  },
  2: {
    api: lastPolicy,
    title: '隐私政策'
  }
};

const props = __props;

const isRegister = ref(props.pageType === LoginTypeEnum.REGISTER);

const codeMsg = ref('获取验证码');
const formRef = ref<BaseFormRef>(null);
const form = ref<FormData>({
  [FormItemEnum.phone]: '',
  [FormItemEnum.code]: '',
  [FormItemEnum.account]: '',
  [FormItemEnum.pwd]: '',
  [FormItemEnum.pwd2]: '',
  [FormItemEnum.agreement]: AgreementEnum.FALSE
});

const countdown = ref<number>(0);
const verificationRef = ref();
const verificationOptions = ref({
  remoteTimerInterval: 800,
  errorText: '请控制拼图块对齐缺口',
  successText: '验证成功',
  remoteApi: {
    initImages: () => {
      return imageJson({
        [FormItemEnum.phone]: form.value[FormItemEnum.phone]
      });
    },
    checkVerification: position => {
      return sendMessageCode({
        [FormItemEnum.phone]: form.value[FormItemEnum.phone],
        ...position
      });
    }
  },
  errorAnimationDuration: 800
});

const rules = ref<BaseFormProps['rules']>({
  [FormItemEnum.phone]: [
    {
      required: true,
      trigger: 'blur',
      validator: validatorPhone
    }
  ],
  [FormItemEnum.code]: [
    {
      required: true,
      trigger: 'blur',
      validator: (_, value, callback) => {
        const regex = /^[0-9]{4}$/;
        if (!value || !regex.test(value)) {
          return callback(new Error('请输入正确验证码'));
        } else {
          callback();
        }
      }
    }
  ],
  [FormItemEnum.account]: [
    { required: true, trigger: 'blur', message: '请您输入正确的账号' }
  ],
  [FormItemEnum.pwd]: [
    { required: true, trigger: 'blur', validator: validatorPassword }
  ],

  [FormItemEnum.pwd2]: [
    {
      required: true,
      trigger: 'blur',
      validator: (_rule, value, callback) => {
        if (!value) {
          callback(new Error('请再次输入密码'));
        } else if (form.value[FormItemEnum.pwd] !== value) {
          callback(new Error('两次密码输入不一致'));
        } else {
          callback();
        }
      }
    }
  ],
  [FormItemEnum.agreement]: [
    {
      required: true,
      trigger: 'blur',
      validator: (_rule, value, callback) => {
        if (!value) {
          if (isRegister.value) {
            return callback(
              new Error(
                `请先阅读并勾选${PLATFORM_NAME}服务平台用户协议&隐私政策`
              )
            );
          }
          return callback(
            new Error(`请先阅读并勾选${PLATFORM_NAME}服务平台用户协议`)
          );
        } else {
          callback();
        }
      }
    }
  ]
});

watch(
  () => props?.formData,
  formData => {
    if (formData) {
      form.value = { ...form.value, ...formData };
    }
  },
  { deep: true, immediate: true }
);

const onInputNumber = (value, prop) => {
  if (value) {
    form.value[prop] = value.replace(/[^\d]/g, '');
  } else {
    form.value[prop] = '';
  }
};

const onGetcode = async () => {
  if (countdown.value) return;
  await formRef.value.validateField(FormItemEnum.phone);
  verificationRef.value.show();
};

const onLookAgreement = async (type: 1 | 2) => {
  const {
    data: { content, releaseAt, takeEffectAt }
  } = await AGREEMENT_MAPPING[type].api();
  XrkMessageBox.alert(
    `<div style="max-height: 500px;overflow-y: auto"><div style="margin-bottom:15px"><h1>更新日期：${formatter.date(
      releaseAt,
      'YYYY-MM-DD'
    )}</h1><h1>生效日期：${formatter.date(
      takeEffectAt,
      'YYYY-MM-DD'
    )}</h1></div> <div>${content}</div></div>`,
    AGREEMENT_MAPPING[type].title,
    {
      customStyle: { width: '800px', maxWidth: '800px' },
      dangerouslyUseHTMLString: true,
      confirmButtonText: '同意',
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          form.value[FormItemEnum.agreement] = AgreementEnum.TRUE;
        }
        done();
      }
    }
  );
};

const checkSuccessful = () => {
  if (countdown.value === 0) {
    countdown.value = 60;
    const intervalId = setInterval(() => {
      if (countdown.value === 1) codeMsg.value = '重新获取验证码';

      if (countdown.value > 0) {
        countdown.value--;
      } else {
        clearInterval(intervalId);
      }
    }, 1000);
  }
};
__expose({
  validate: (...args: any) => formRef.value?.validate(...args),
  resetFields: (...args: any) => formRef.value?.resetFields(...args),
  data: form
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    class: "user-login-form",
    ref_key: "formRef",
    ref: formRef,
    model: form.value,
    rules: rules.value
  }, {
    default: _withCtx(() => [
      (_ctx.itemList.includes(_unref(FormItemEnum).phone))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(BaseFormItem), {
              prop: _unref(FormItemEnum).phone
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  inputStyle: { height: '40px' },
                  maxlength: 11,
                  clearable: "",
                  modelValue: form.value[_unref(FormItemEnum).phone],
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value[_unref(FormItemEnum).phone]) = $event)),
                  placeholder: "请输入手机号",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (onInputNumber($event, _unref(FormItemEnum).phone)))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["prop"]),
            _createVNode(_unref(BaseFormItem), {
              prop: _unref(FormItemEnum).code
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(BaseInput), {
                    class: "user-login-form-inputcode",
                    inputStyle: { height: '40px' },
                    clearable: "",
                    maxlength: 4,
                    modelValue: form.value[_unref(FormItemEnum).code],
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value[_unref(FormItemEnum).code]) = $event)),
                    placeholder: "请输入验证码",
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (onInputNumber($event, _unref(FormItemEnum).code)))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(XrkSlideVerify), {
                    ref_key: "verificationRef",
                    ref: verificationRef,
                    options: verificationOptions.value,
                    onSuccess: checkSuccessful
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BaseButton), {
                        click: onGetcode,
                        disable: Boolean(countdown.value),
                        class: _normalizeClass([
                'user-login-form-getcode',
                countdown.value ? 'user-login-form-diabled-btn' : ''
              ])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(countdown.value || codeMsg.value), 1)
                        ]),
                        _: 1
                      }, 8, ["disable", "class"])
                    ]),
                    _: 1
                  }, 8, ["options"])
                ])
              ]),
              _: 1
            }, 8, ["prop"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.itemList.includes(_unref(FormItemEnum).account))
        ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
            key: 1,
            prop: _unref(FormItemEnum).account
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                style: {"width":"100%"},
                type: "text",
                placeholder: "请输入账号",
                clearable: "",
                inputTextReplace: "",
                inputTexts: ['英文字母', '数字', '中文'],
                maxlength: 16,
                inputStyle: { height: '40px' },
                modelValue: form.value[_unref(FormItemEnum).account],
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value[_unref(FormItemEnum).account]) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["prop"]))
        : _createCommentVNode("", true),
      (_ctx.itemList.includes(_unref(FormItemEnum).pwd))
        ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
            key: 2,
            prop: _unref(FormItemEnum).pwd
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                type: "password",
                placeholder: "请输入密码",
                style: {"width":"100%"},
                "show-password": "",
                inputStyle: { height: '40px' },
                maxlength: 8,
                modelValue: form.value[_unref(FormItemEnum).pwd],
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value[_unref(FormItemEnum).pwd]) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["prop"]))
        : _createCommentVNode("", true),
      (_ctx.itemList.includes(_unref(FormItemEnum).pwd2))
        ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
            key: 3,
            prop: _unref(FormItemEnum).pwd2
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseInput), {
                type: "password",
                placeholder: "请再次输入密码",
                style: {"width":"100%"},
                "show-password": "",
                inputStyle: { height: '40px' },
                maxlength: 8,
                modelValue: form.value[_unref(FormItemEnum).pwd2],
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value[_unref(FormItemEnum).pwd2]) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["prop"]))
        : _createCommentVNode("", true),
      (_ctx.itemList.includes(_unref(FormItemEnum).agreement))
        ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
            key: 4,
            prop: _unref(FormItemEnum).agreement,
            style: {"margin-bottom":"28px","height":"26px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(BaseCheckbox), {
                  modelValue: form.value[_unref(FormItemEnum).agreement],
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value[_unref(FormItemEnum).agreement]) = $event)),
                  trueValue: _unref(AgreementEnum).TRUE,
                  falseValue: _unref(AgreementEnum).FALSE
                }, null, 8, ["modelValue", "trueValue", "falseValue"]),
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (onLookAgreement(1)))
                  }, " 《" + _toDisplayString(_unref(PLATFORM_NAME)) + "服务平台用户协议》 ", 1),
                  (isRegister.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (onLookAgreement(2))),
                        style: {"margin-top":"-10px"}
                      }, " 《隐私政策》 "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["prop"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})